import { useLocation } from "react-router-dom";
import {
  isUserAdmin,
  isUserContentAdmin,
  isUserCustomerService,
} from "services/authUtil";
import ContentAdminRoutes from "components/routes/ContentAdminRoutes";
import AdminRoutes from "components/routes/AdminRoutes";
import CustomerServiceRoutes from "components/routes/CustomerServiceRoutes";
import UserRoutes from "components/routes/UserRoutes";
import UnauthRoutes from "components/routes/UnauthRoutes";
import useUser from "hooks/useUser";

interface RoutesProps {
  smallWindow: boolean;
  showToast: (message: string) => void;
  // These 2 props are actually set by PageLayout component through cloning mechanic 🤡.
  openSidebar?: (selection: any, mode: any) => void;
  refreshHeader?: () => void;
}

export function RouteList({ smallWindow, showToast, ...props }: RoutesProps) {
  const location = useLocation();
  const user = useUser();

  if (!user) {
    return (
      <UnauthRoutes location={location} smallWindow={smallWindow} showToast={showToast} />
    );
  }

  if (isUserContentAdmin()) {
    return (
      <ContentAdminRoutes
        location={location}
        smallWindow={smallWindow}
        showToast={showToast}
      />
    );
  }

  if (isUserAdmin()) {
    return (
      <AdminRoutes location={location} smallWindow={smallWindow} showToast={showToast} />
    );
  }

  if (isUserCustomerService()) {
    return (
      <CustomerServiceRoutes
        location={location}
        smallWindow={smallWindow}
        showToast={showToast}
      />
    );
  }

  return (
    <UserRoutes
      location={location}
      smallWindow={smallWindow}
      showToast={showToast}
      openSidebar={props.openSidebar}
      refreshHeader={props.refreshHeader}
    />
  );
}
